import React from 'react'

export default function Footer() {
  return (
   <>
   <nav style={{ backgroundColor:"#ff8f0063" , marginBottom:"-56px" , position:"sticky" }}>
     <h4 style={{color:"white" , textAlign:"center"}}> All Copyrights &copy; are reserved by Shardul Chaudhary </h4>
     <p><a href='https://www.instagram.com/_shardul_1210/'><i class="fa-brands fa-instagram" style={{color:"white" , marginRight:"10px"}}></i></a> <a href='https://www.linkedin.com/in/shardul-chaudhary-bab4b0260/'><i class="fa-brands fa-linkedin" style={{color:"white"}}></i></a> <a href='https://www.shardul1210@gmail.com'><i class="fa-solid fa-envelope" style={{color:"white", marginLeft:"10px"}}></i></a></p>
   </nav>
   </>
  )
}
